import { useEffect } from "react";
import { CustomCountDropdownPopup } from "./custom-count-dropdown";

export const ServerSideCustomPagination = ({
  rowsPerPage,
  setRowsPerPage,
  handlePerPageChange,
  disablePagination,
  rowCount,
  onChangePage,
  currentPage,
  totalPages,
  hasPrevious,
  hasNext,
  customstyles,
}) => {
  const parsedCurrentPage = Number(currentPage) || 0; // Ensure integer
  const parsedRowsPerPage = Number(rowsPerPage) || 10; // Default to 10 if undefined

  const handleBackButtonClick = () => {
    if (hasPrevious) onChangePage(parsedCurrentPage - 1);
  };

  const handleNextButtonClick = () => {
    if (hasNext) onChangePage(parsedCurrentPage + 1);}
  useEffect(() => {}, [disablePagination]);

  return (
    <div
      style={
        customstyles
          ? customstyles
          : {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "10px",
              gap: "10px",
              fontFamily: "Arial, sans-serif",
            }
      }
    >
      {/* Dropdown for Rows Per Page */}
      <div className="relative w-[81px] h-[30px]">
                <CustomCountDropdownPopup onChange={handlePerPageChange} value={rowsPerPage} />
        <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
          <svg
            className="w-5 h-5 text-blue-500"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M5.23 7.21a.75.75 0 011.06-.02L10 10.67l3.71-3.48a.75.75 0 011.06 1.06l-4.24 4a.75.75 0 01-1.06 0l-4.24-4a.75.75 0 01-.02-1.06z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      </div>

      {/* Page Information */}
      <span style={{ fontSize: "14px", color: "#333" }}>
        <span style={{ color: "rgba(27, 42, 61, 1)" }} className="font-[600]">
          {parsedCurrentPage * parsedRowsPerPage + 1} -{" "}
          {Math.min((parsedCurrentPage + 1) * parsedRowsPerPage, rowCount)}
        </span>{" "}
        of{" "}
        <span style={{ color: "rgba(27, 42, 61, 1)" }} className="font-[600]">
          {rowCount}
        </span>{" "}
        items
      </span>

      {/* Pagination Buttons */}
      <button
        onClick={handleBackButtonClick}
        disabled={!hasPrevious || disablePagination}
        style={{
          border: hasPrevious
            ? "1px solid rgba(36, 92, 234, 1)"
            : "1px solid rgba(36, 92, 234, 0.5)",
          background: "#fff",
          color: hasPrevious
            ? "rgba(36, 92, 234, 1)"
            : "rgba(36, 92, 234, 0.5)",
          padding: "1px 10px",
          cursor: hasPrevious ? "pointer" : "not-allowed",
          borderRadius: "5px",
        }}
      >
        ‹
      </button>
      <button
        onClick={handleNextButtonClick}
        disabled={!hasNext || disablePagination}
        style={{
          border: hasNext
            ? "1px solid rgba(36, 92, 234, 1)"
            : "1px solid rgba(36, 92, 234, 0.5)",
          background: "#fff",
          color: hasNext ? "rgba(36, 92, 234, 1)" : "rgba(36, 92, 234, 0.5)",
          padding: "1px 10px",
          cursor: hasNext ? "pointer" : "not-allowed",
          borderRadius: "5px",
        }}
      >
        ›
      </button>
    </div>
  );
};
